// tslint:disable:max-line-length
import * as React from 'react';

export const reliably = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
    <path fillRule="evenodd" d="M10.65 2.821l-.383-.254A25.837 25.837 0 0 1 7 0a26.935 26.935 0 0 1-3.267 2.567A231.97 231.97 0 0 1 0 5v1h1v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V6h1V5c-.76-.486-1.503-.965-2.227-1.439a50.211 50.211 0 0 0-4.693 8.272C6.127 9.883 4.29 7.376 3 6.05l1.236-1.427a19.497 19.497 0 0 1 2.768 3.652c.903-1.73 2.261-3.688 3.645-5.453z"/>
  </svg>
);

// tslint:enable:max-line-length
